
(function($){
    $(document).ready(function(){
        $('.list-partner').each(function(){
            const tnsSlider = tns({
                container: $(this).find('.container-wrapper')[0],
                items: 1.8,
                gutter: 20,
                edgePadding: 20,
                autoplay: false,
                autoplayButtonOutput: false,
                nav: false,
                controlsText: ['<i class="fa-light fa-arrow-left"></i>','<i class="fa-light fa-arrow-right"></i>'],
                lazyload: true,
                speed: 1000,
                mouseDrag: true,
                autoplayTimeout: 8000,
                responsive: {
                    640: {
                    gutter: 20,
                    items: 2
                    },
                    900: {
                    items: 4
                    },
                    1200:{
                        items: 5
                    },
                    1600:{
                        items: 6
                    }
                }
            });
        });
    });

})(jQuery);